import { render, staticRenderFns } from "./tempPenNaikPangkatMohonKUP.vue?vue&type=template&id=2c4d6802&"
import script from "./tempPenNaikPangkatMohonKUP.vue?vue&type=script&lang=js&"
export * from "./tempPenNaikPangkatMohonKUP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports